import React, {useState,useEffect} from 'react'
import {
    useParams,
    Navigate,
    Link
} from 'react-router-dom';
import axios from "axios"
import Loader from '../../../components/Loader';
import axiosInstance from '../../../utils/api';

type Props = {}
interface PumpInterface {
    serial: string;
    brand?: string;
    node?: string;
    model?: string;
    data?:string;
}

const PumpAddEdit = (props: Props) => {
    const {type, id} = useParams()
    const [loading, setLoading] = useState(false)
    const [inputs, setInputs] = useState([
        {
            serial: "",
            brand: "SEKO",
            node: "",
            model: "DMS200"
        }
    ])
    const [input, setInput] = useState<PumpInterface>(
        {
            serial: "",
            brand: "SEKO",
            node: "",
            model: "DMS200"
        }
    )

    useEffect(() => {
        if (type=="edit" && id) {
            getData(id)
        }
    }, [])


    if (type!="add"&&type!="edit") {
        console.log(1, type)
        return <Navigate to="/" replace={true} />
    } else if (type=="add"&& id) {
        console.log(2, type)
        return <Navigate to="/" replace={true} />
    } else if (type=="edit"&& !id) {
        console.log(3, type)
        return <Navigate to="/" replace={true} />
    }

    
    function getData(id:string):void {
        setLoading(true)
        axiosInstance.get(`https://api.cl-ds.com/internal/operations/v1/pump/${id}`).then(res => {
            setLoading(false)
            console.log(12, res)
            setInput(res.data)
        }).catch(err => {
            setLoading(false)
            console.log(234, err)
            return <Navigate to="/" replace={true} />
        })
    }
    

    function handleSubmit() {
        if (type=="add") {
            console.log("add", inputs)

            for (let i in inputs) {
                if (inputs[i].serial.length < 1) {
                    return alert("Serial is required")
                }
                if (inputs[i].brand.length < 1) {
                    return alert("Brand is required")
                }
                if (inputs[i].model.length < 1) {
                    return alert("Model is required")
                }
            }

            setLoading(true)
            axiosInstance.post("https://api.cl-ds.com/internal/operations/v1/pump/", inputs).then((res:any) =>{
                setLoading(false)
                alert(res.data.message)
            }).catch( err => {
                setLoading(false)
                console.log(222, err)
            })
        } else {
            console.log("edit", input)

            if (input.serial.length < 1) {
                return alert("Serial is required")
            }
            if (input.brand!.length < 1) {
                return alert("Brand is required")
            }
            if (input.model!.length < 1) {
                return alert("Model is required")
            }

            setLoading(true)
            axiosInstance.put(`https://api.cl-ds.com/internal/operations/v1/pump/${id}/`, input).then((res:any) =>{
                setLoading(false)
                alert(res.data.message)
            }).catch( err => {
                setLoading(false)
                console.log(222, err)
            })
        }
    }

    function handleChange(e:React.ChangeEvent<HTMLInputElement>,field: string, index?:number ) {
        console.log("handleChange", inputs)
        if (index!=null) {
            let newArr = [...inputs]
            newArr[index] = {
                ...newArr[index],
                [field]: e.target.value
            }
    
            setInputs(newArr)
        } else {
            setInput(prev => ({
                ...prev,
                [field]: e.target.value
            }))
        }
    }

    function addInput() {
        setInputs(prev => [...prev , {
            serial: "",
            brand: "SEKO",
            node: "",
            model: "DMS200"
        }])
    }

    
    function removeInput(index:number) {
        let newArr = inputs.filter( (input, i) => i != index)
        setInputs(newArr)
    }

    function handleChangeSelect(e:React.ChangeEvent<HTMLSelectElement>, index?:number) {
        console.log("handleChangeSelect", inputs, index)
        if (index!=null) {
            let newArr = [...inputs]
            newArr[index] = {
                ...newArr[index],
                "serial": e.target.value
            }
    
            setInputs(newArr)
        } else {
            setInput(prev => ({
                ...prev,
                "serial": e.target.value
            }))
        }
    }

    return (
        <div className="col-12">
        {loading && ( <Loader/> )}

            <div className="card">
                <div className="card-body">
                <div style={{float: "right", margin: "1rem", marginLeft: 0, marginBottom: 0}}>
                    <Link  to={`/pump`} className="nav-link collapsed">
                        <button type="button" className="btn btn-outline-secondary">Back</button>
                    </Link>
                </div>
                <h5 className="card-title">{type=="add" ? "Create" : "Edit"} Sensor</h5>

                    {type == "add" && 
                        inputs.map( (input, index) => {
                            return (
                                <div style={{border:"1px dashed gray", padding: "1rem", borderRadius: 10, marginBottom:"1rem"}} key={index}>
                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">Serial #{index}</label>
                                        <div className="col-sm-8">
                                            <input type="text" className="form-control" id="inputText" value={input.serial} onChange={(e)=>handleChange(e, "serial", index)}/>
                                        </div>
                                    </div>
                                    
                                    
                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">Brand</label>
                                        <div className="col-sm-8">
                                            <input type="text" className="form-control" id="inputText" value={input.brand} onChange={(e)=>handleChange(e, "brand", index)}/>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">Model</label>
                                        <div className="col-sm-8">
                                            <input type="text" className="form-control" id="inputText" value={input.model} onChange={(e)=>handleChange(e, "model", index)}/>
                                        </div>

                                        <div className="col-sm-1" onClick={()=>{addInput()}}>
                                            <button type="button" className="btn btn-outline-info"><i className="bi bi-plus"></i></button>
                                        </div>
                                        {index!=0 && (
                                        <div className="col-sm-1" onClick={()=>{removeInput(index)}}>
                                            <button type="button" className="btn btn-outline-danger"><i className="bi bi-dash"></i></button>
                                        </div>
                                        )}
                                    </div>

                                </div>
                            )
                        })
                    }

                    {type == "edit" && 
                        <>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Serial</label>
                            <div className="col-sm-10">
                                <input type="text" className="form-control" id="inputText" value={input.serial} onChange={(e)=>handleChange(e, "serial")} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Node</label>
                            <div className="col-sm-10">
                                <input type="text" className="form-control" id="inputText" value={input.node} disabled/>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Brand</label>
                            <div className="col-sm-10">
                                <input type="text" className="form-control" id="inputText" value={input.brand} onChange={(e)=>handleChange(e, "brand")} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Model</label>
                            <div className="col-sm-10">
                                <input type="text" className="form-control" id="inputText" value={input.model} onChange={(e)=>handleChange(e, "model")} />
                            </div>
                        </div>
                        <div className="row mb-3">
                            <label className="col-sm-2 col-form-label">Data</label>
                            <div className="col-sm-10">
                                <input type="text" className="form-control" id="inputText" value={input.data} onChange={(e)=>handleChange(e, "data")} />
                            </div>
                        </div>
                        </>
                    }
                    
                    <div className="text-start">
                        <button type="button" className="btn btn-outline-info" onClick={()=>handleSubmit()}>Submit</button>
                    </div>          

                </div>
            </div>

        </div>
    )
}

export default PumpAddEdit